// removed by extract-text-webpack-plugin
module.exports = {"root":"Mods--root--2b","accessory":"Mods--accessory--2u","main":"Mods--main--2P","description":"Mods--description--2w","energyType":"Mods--energyType--2i","arc":"Mods--arc--BL","solar":"Mods--solar--1C","void":"Mods--void--3m","stasis":"Mods--stasis--1Y"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Mods/detailedMod.styl
// module id = 895
// module chunks = 0